import "./App.css";
import Aviator from "./components/aviator";
import SVGs from "./components/svgs";
import AviatorProvider from "./store/aviator";
import SocketProvider from "./providers/SocketProvider";
import { ReduxProvider } from "./providers/ReduxProvider";
import SocketReduxConnector from "./components/SocketReduxConnector";
import AuthWrapper from "./components/AuthWrapper/AuthWrapper";

import { BrowserRouter, Route, Routes } from "react-router-dom";

function App() {
  return (
    <>
      <SVGs />
      <ReduxProvider>
        <BrowserRouter
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <AuthWrapper>
            <SocketProvider>
              <SocketReduxConnector />
              <AviatorProvider>
                <Routes>
                  {/* PlayFortune launch contract: /auth/:eventId/:token/:currency */}
                  <Route path="/auth/:eventId/:token" element={<Aviator />} />
                  <Route path="/auth/:eventId/:token/:currency" element={<Aviator />} />
                  <Route path="/auth/*" element={<Aviator />} />
                  <Route path="/demo" element={<Aviator />} />
                  <Route path="/" element={<Aviator />} />
                </Routes>
              </AviatorProvider>
            </SocketProvider>
          </AuthWrapper>
        </BrowserRouter>
      </ReduxProvider>
    </>
  );
}

export default App;
